/** Base used for Universal Links / App Links (see app.mighty45.com AASA + Android assetlinks). */
const CONNECT_INVITE_BASE_URL = "https://app.mighty45.com/connect";

/**
 * Mighty45 connect / invite deep link (no Firebase Dynamic Links).
 *
 * @param {object} params
 * @param {string} params.connectCode
 * @param {string} [params.organizationName]
 * @param {string} [params.organizationId]
 * @param {string} [params.type]
 * @returns {string|null}
 */
export function buildConnectInviteUrl({
  connectCode,
  organizationName = "",
  organizationId = "",
  type = "client",
} = {}) {
  if (!connectCode) {
    return null;
  }

  const searchParams = new URLSearchParams({
    connectCode: String(connectCode),
    orgName: organizationName ? String(organizationName) : "",
    orgId: organizationId ? String(organizationId) : "",
    type: type ? String(type) : "client",
  });

  return `${CONNECT_INVITE_BASE_URL}?${searchParams.toString()}`;
}

/**
 * Shape kept for older call sites that expected Firebase short-link API responses.
 *
 * @returns {{ shortLink: string, previewLink: string } | null}}
 */
export function buildConnectInviteLinkPayload(params) {
  const url = buildConnectInviteUrl(params);
  if (!url) {
    return null;
  }
  return { shortLink: url, previewLink: url };
}
